import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import looppa from 'looppa';
import mapFacets from 'util/react/facet';

/**
 * Check if the child component is an icon
 */
function isIcon(child) {
    return child && child.props && child.props.displayName === 'Icon';
}

export default function Button(props) {
    let { children, size, facet, className, tag, hasFocus, disabled, ...additionalProps } = props; // eslint-disable-line
    const Tag = props.tag === 'a' ? Link : props.tag;

    // normalize always the children property in order to get an array back
    if (!Array.isArray(children)) {
        children = [children];
    }

    // remove empty values
    children = children.filter(c => c);

    return (
        <Tag
            {...additionalProps}
            role="button"
            disabled={disabled}
            className={classnames([
                'btn',
                mapFacets(facet, 'btn'),
                `btn__${ size }`, className,
                {
                    'btn__has-focus': hasFocus,
                },
            ])}>
            <div className="btn--wrap">
                {looppa(children)((child, i) => (
                    <div key={i}
                        className={isIcon(child) ? 'btn--icon' : 'btn--text'}>
                        <div className="btn--cell">
                            <div className="btn--content">
                                {child}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Tag>
    );
}

Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]).isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    hasFocus: PropTypes.bool,
    facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    size: PropTypes.string,
    tag: PropTypes.oneOf(['a', 'button']).isRequired,
};

Button.defaultProps = {
    className: '',
    disabled: false,
    hasFocus: false,
    size: 'medium',
    facet: 'base',
    tag: 'button',
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/button/index.js